import { apiRequest } from '../http';
import { ActivityKpiRow, NovedadKpiRow, PagedResult, ReportFilters, UserKpiRow } from './types';

function qs(filters: ReportFilters, page: number, pageSize: number): string {
  const params = new URLSearchParams();
  Object.entries({ ...filters, page: String(page), pageSize: String(pageSize) }).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
  });
  return params.toString();
}

/** Repositorio de Reportes/KPIs (Esq_OperationTimes, agregaciones de solo lectura). */
export class ReportsRepository {
  constructor(private getToken: () => Promise<string | null>) {}

  async byActivity(filters: ReportFilters, page: number, pageSize: number): Promise<PagedResult<ActivityKpiRow>> {
    const token = await this.getToken();
    return apiRequest(`/api/reports/kpis/by-activity?${qs(filters, page, pageSize)}`, { token });
  }

  async byUser(filters: ReportFilters, page: number, pageSize: number): Promise<PagedResult<UserKpiRow>> {
    const token = await this.getToken();
    return apiRequest(`/api/reports/kpis/by-user?${qs(filters, page, pageSize)}`, { token });
  }

  async novedades(filters: ReportFilters, page: number, pageSize: number): Promise<PagedResult<NovedadKpiRow>> {
    const token = await this.getToken();
    return apiRequest(`/api/reports/kpis/novedades?${qs(filters, page, pageSize)}`, { token });
  }
}
